export const PERMISSION_FACTURACION_ELECTRONICA = 'facturacion_electronica';
